export default {
  init() {
    // JavaScript to be fired on the about us page

    $(".lbt").on("click", function () {
      let target = $(this).attr("data-target");
      let base = $(".about--live-by");
      base.find(".lbt.active").removeClass("active");
      base.find(".about--live-by--text--inner.active").removeClass("active");
      base.find(".about--live-by--img.active").removeClass("active");
      $(this).addClass("active");
      base.find(`.about--live-by--text--inner__${target}`).addClass("active");
      base.find(`.about--live-by--img__${target}`).addClass("active");
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/about.js